import React, {Component} from 'react';
import {
    HeaderNavigation,
    ALIGN,
    StyledNavigationList,
    StyledNavigationItem
} from "baseui/header-navigation";
import { StyledLink } from "baseui/link";
import logo_32 from '../images/enclock_32x32.png';
import linux_logo from '../images/platforms/linux/linux.svg';
import windows_logo from '../images/platforms/windows/windows.svg';
import mac_logo from '../images/platforms/macos/mac.svg';
import android_logo from '../images/platforms/android/android.svg';
import * as ROUTES from '../Routes';

class Navigation extends Component {

    render = () => {
        // Do not show the navigation in home page.
        if (['/', ''].includes(window.location.pathname)) {
            return null;
        }
        return <HeaderNavigation
                style={{borderBottomWidth: '0px', marginBottom: '10px', marginTop: '10px', paddingLeft: '20px', paddingRight: '20px'}}
                overrides={{
                    Root: {
                        style: ({ $theme }) => ({
                            backgroundColor: $theme.colors.primaryB
                        })
                    }
                }}
            >
            <StyledNavigationList $align={ALIGN.left}>
                <StyledNavigationItem style={{margin: 0, padding: 0, lineHeight: '0px'}}>
                    <StyledLink stle={{marginTop: '3px'}} href={ROUTES.WALL}><img alt={''} src={logo_32} style={{border: '1px solid gray', borderRadius: '5px'}}/></StyledLink>
                </StyledNavigationItem>
            </StyledNavigationList>
            <StyledNavigationList $align={ALIGN.center} />
            <StyledNavigationList $align={ALIGN.right}>
                <StyledNavigationItem style={{margin: 0, lineHeight: '0px'}}>
                    <StyledLink href={ROUTES.MICROSOFT}><img alt={''} width={'32px'} src={windows_logo}/></StyledLink>
                </StyledNavigationItem>
                <StyledNavigationItem style={{margin: 0, lineHeight: '0px'}}>
                    <StyledLink href={ROUTES.APPLE}><img alt={''} width={'32px'} src={mac_logo}/></StyledLink>
                </StyledNavigationItem>
                <StyledNavigationItem style={{margin: 0, lineHeight: '0px'}}>
                    <StyledLink href={ROUTES.LINUX}><img alt={''} width={'32px'} src={linux_logo}/></StyledLink>
                </StyledNavigationItem>
                <StyledNavigationItem style={{margin: 0, lineHeight: '0px'}}>
                    <StyledLink href={ROUTES.ANDROID}><img alt={''} width={'32px'} src={android_logo}/></StyledLink>
                </StyledNavigationItem>
            </StyledNavigationList>
      </HeaderNavigation>
    };
}

export default Navigation;